module.exports = __webpack_public_path__ + "img/local-6.460dffe5.jpg";